import React, { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

interface ReadOnlyTitleViewProps {
    titleContent: string;
    titleHeader: string;
    titleContentStyle?: CSSProperties;
    titleHeaderStyle?: CSSProperties;
    truncateText?: boolean;
    widthPerCharacter?: number;
}

const containerStyle: CSSProperties = {
    display: 'grid',
    minWidth: 200,
    backgroundColor: 'transparent',
};

const defaultTitleContentStyle: CSSProperties = {
    fontSize: 22,
    fontWeight: Size.FontWeight.Regular,
    maxWidth: '95%',
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

const defaultTitleHeaderStyle: CSSProperties = {
    fontSize: 15,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

export const ReadOnlyTitleView = ({
    titleContent,
    titleHeader,
    titleContentStyle,
    titleHeaderStyle,
    truncateText,
}: ReadOnlyTitleViewProps) => (
    <div style={containerStyle}>
        <div style={{ ...defaultTitleHeaderStyle, ...titleHeaderStyle }} title={titleHeader}>
            {titleHeader}
        </div>
        <div style={{ ...defaultTitleContentStyle, ...titleContentStyle }} title={titleContent}>
            {titleContent}
        </div>
    </div>
);
